var _g, _g2, _g3, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFollowers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "139 130 72.73 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2190_11198)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 148,
    r: 18,
    fill: "url(#paint0_linear_2190_11198)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2190_11198)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.5,
    cy: 188,
    rx: 26.5,
    ry: 18,
    fill: "url(#paint1_linear_2190_11198)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2190_11198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.581 167.186C191.475 167.186 191.368 167.186 191.262 167.151C189.81 167.292 188.322 166.265 188.181 164.813C188.039 163.361 188.925 162.051 190.377 161.874C190.802 161.838 191.262 161.838 191.652 161.838C196.822 161.555 200.86 157.305 200.86 152.099C200.86 146.715 196.504 142.359 191.12 142.359C189.668 142.395 188.464 141.19 188.464 139.738C188.464 138.286 189.668 137.082 191.12 137.082C199.408 137.082 206.172 143.847 206.172 152.134C206.172 160.28 199.797 166.867 191.687 167.186C191.652 167.186 191.616 167.186 191.581 167.186Z",
    fill: "url(#paint2_linear_2190_11198)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2190_11198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.955 199.061C196.715 199.061 195.617 198.211 195.37 196.936C195.086 195.484 196.007 194.103 197.424 193.784C199.655 193.323 201.709 192.438 203.303 191.198C205.322 189.676 206.42 187.763 206.42 185.744C206.42 183.726 205.322 181.813 203.338 180.326C201.78 179.121 199.832 178.271 197.53 177.74C196.113 177.421 195.192 176.005 195.511 174.553C195.83 173.136 197.247 172.215 198.699 172.534C201.745 173.207 204.401 174.411 206.561 176.076C209.855 178.555 211.732 182.061 211.732 185.744C211.732 189.428 209.82 192.934 206.526 195.448C204.33 197.148 201.567 198.388 198.522 198.99C198.309 199.061 198.132 199.061 197.955 199.061Z",
    fill: "url(#paint3_linear_2190_11198)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2190_11198",
    x: 8.89816,
    y: 0.898163,
    width: 576.204,
    height: 576.204,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 132,
    dy: 141
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 135.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0416667 0 0 0 0 0.1375 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2190_11198"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2190_11198",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2190_11198",
    x: 0.898163,
    y: 40.8982,
    width: 593.204,
    height: 576.204,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 132,
    dy: 141
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 135.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0416667 0 0 0 0 0.1375 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2190_11198"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2190_11198",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2190_11198",
    x: 50.0642,
    y: 7.98019,
    width: 558.21,
    height: 570.307,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 132,
    dy: 141
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 135.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0416667 0 0 0 0 0.1375 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2190_11198"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2190_11198",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2190_11198",
    x: 57.2165,
    y: 43.3689,
    width: 556.618,
    height: 566.794,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 132,
    dy: 141
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 135.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0416667 0 0 0 0 0.1375 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2190_11198"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2190_11198",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2190_11198",
    x1: 158.957,
    y1: 120.534,
    x2: 158.957,
    y2: 176.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDD4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2190_11198",
    x1: 156.603,
    y1: 160.534,
    x2: 156.603,
    y2: 216.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDD4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2190_11198",
    x1: 194.147,
    y1: 129.166,
    x2: 194.147,
    y2: 176.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDD4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2190_11198",
    x1: 200.77,
    y1: 165.479,
    x2: 200.77,
    y2: 207.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDD4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253BFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowers);
export default __webpack_public_path__ + "static/media/followers.bf8f6862c5655c86bc821b158a359aed.svg";
export { ForwardRef as ReactComponent };